export const lifecycleGate = {
label: {
draft: "مسودة",
open: "مفتوح",
accepted: "مقبول",
awaiting_assignee_response: "بانتظار القبول",
assignee_declined: "مرفوض من المكلَّف",
scheduled: "مجدول",
in_progress: "قيد التنفيذ",
paused: "متوقف مؤقتًا",
completion_submitted: "بانتظار الاعتماد",
completion_rejected: "طُلب إعادة العمل",
completion_verified: "معتمدة",
awaiting_follow_on_approval: "بانتظار الموافقة",
cancelled: "ملغى",
skipped: "تم التخطي",
},
shortLabel: {
draft: "مسودة",
open: "مفتوح",
accepted: "مقبول",
awaiting_assignee_response: "بالانتظار",
assignee_declined: "مرفوض",
scheduled: "مجدول",
in_progress: "جارٍ",
paused: "متوقف",
completion_submitted: "مُرسَل",
completion_rejected: "إعادة عمل",
completion_verified: "معتمدة",
awaiting_follow_on_approval: "موافقة",
cancelled: "ملغى",
skipped: "تم التخطي",
},
nextActor: {
draft: "{{name}} ينهي المسودة",
open: "{{name}} يقبل أمر العمل",
awaiting_assignee_response: "{{name}} يقبل أو يرفض",
assignee_declined: "{{name}} يعيد تعيين أمر العمل",
scheduled: "{{name}} يبدأ العمل",
in_progress: "{{name}} يُرسل الإنجاز",
paused: "{{name}} يستأنف عند إزالة العائق",
completion_submitted: "{{name}} يراجع الإنجاز",
completion_rejected: "{{name}} يعيد العمل",
completion_verified: "أمر العمل مغلق",
awaiting_follow_on_approval: "{{name}} يتخذ القرار",
cancelled: "لا حاجة إلى إجراء آخر",
skipped: "لا حاجة إلى إجراء آخر",
},
nextActorYou: {
draft: "تُنهي المسودة",
open: "تقبل أمر العمل",
awaiting_assignee_response: "تقبل أو ترفض",
assignee_declined: "تعيد تعيين أمر العمل",
scheduled: "تبدأ العمل",
in_progress: "تُرسل الإنجاز",
paused: "تستأنف عند إزالة العائق",
completion_rejected: "تعيد العمل",
completion_submitted: "تراجع الإنجاز",
evidence_requested: "تضيف الأدلة المطلوبة وتعيد الإرسال",
awaiting_follow_on_approval: "توافق على المتابعة أو ترفضها",
},
};
